import { createSelector } from 'reselect';

const flagsSelector = (state) => state.api.flags;

export const getFlags = createSelector(flagsSelector, (data) => {
  return data;
});
